
export const basic = {
  http: process.env.NODE_ENV === 'development' ? 'https://zhaokao.hfhuihan.com' : location.origin,
  curHttp:process.env.NODE_ENV === 'development' ? 'https://zhaokao.hfhuihan.com' : location.origin
}
